module.exports = __webpack_public_path__ + "img/reboot.07a3ad11.svg";